import { defineStore } from "pinia";
import { ref } from "vue";

export const useTreasureActivityStore = defineStore("treasureActivity", () => {
  const rechargeRequire = ref("");
  const turnoverRequire = ref("");
  const ipLimit = ref("")

  const setActivityData = (rechargeValue : string, turnOverValue : string, ip: string): void => {
    rechargeRequire.value = rechargeValue;
    turnoverRequire.value =  turnOverValue;
    ipLimit.value = ip
  }

  return {
    rechargeRequire,
    turnoverRequire,
    ipLimit,
    setActivityData
  };
}, {
  persist: true,
});
